import { Component } from 'react';
import {connect} from 'react-redux';
import {FormGroup, FormLabel} from 'react-bootstrap';
import {actions, Errors} from 'forms/rrf';
import CKEditor from '../../../common/editor/ckeditor4';
import { getEnvironmentVariable } from '../../../../actions/environment-variable';
import './styles.css';

import store from './../../../../store';

class Editor extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.licenseKey.length === 0) {
      this.props.dispatch(getEnvironmentVariable('REACT_APP_CKEDITOR_LICENSE_KEY'));
    }
  }

  onChange = (value) => {
    const htmlCode = value.toString('html');
    store.dispatch(actions.change(this.props.field, htmlCode));

    if (this.props.onChange) {
      this.props.onChange(htmlCode);
    }
  };

  render() {
    if (this.props.licenseKey.length === 0) {
      return (
        <div>Loading editor...</div>
      );
    }

    return (
      <FormGroup>
        <FormLabel>
          Body*
        </FormLabel>
        <CKEditor
          activeClass={this.props.field}
          config={{
            toolbar:
              [
                {
                  name: 'clipboard',
                  items: ['Cut', 'Copy', 'Paste', 'PasteText', 'MediaEmbed', 'PasteFromWord', '-', 'Undo', 'Redo']
                },
                {
                  name: 'editing',
                  items: ['Find', 'Replace', '-', 'SelectAll']
                },
                {
                  name: 'tools',
                  items: ['Maximize', '-', 'About']
                },
                {
                  name: 'document',
                  items: ['Source']
                },
                '/',
                {
                  name: 'paragraph',
                  items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv',
                    '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
                },
                {
                  name: 'links',
                  items: ['Link', 'Unlink', 'Anchor']
                },
                {
                  name: 'insert',
                  items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'Iframe']
                },
                '/',
                {
                  name: 'basicstyles',
                  items: [
                    'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'
                  ]
                },
                {
                  name: 'styles',
                  items: ['Styles', 'Format', 'Font', 'FontSize']
                },
                {
                  name: 'colors',
                  items: ['TextColor', 'BGColor']
                },
              ],
            extraPlugins: 'mediaembed,find,selectall,div,justify,smiley,specialchar,iframe,font,colorbutton',
            extraAllowedContent: 'iframe[fullscreen,allowfullscreen]',
            removedButtons: '',
            licenseKey: this.props.licenseKey,
            versionCheck: false
          }}
          content={this.props.content}
          events={{
            change: event => this.onChange(event.editor.getData())
          }}
          scriptUrl="/api/ckeditor/ckeditor.js"
        />
        <Errors
          className="errors"
          model={this.props.field}
          show={{
            touched: true,
            focus: false
          }}
        />

      </FormGroup>
    );
  }
}

const mapStateToProps = state => ({
  licenseKey: state.environmentVariable.environmentVariableValue
});

export default connect(mapStateToProps)(Editor);
